import React, { useEffect, useState } from 'react';
import { Card, Toast } from 'antd-mobile';

import Statistic from '../components/Statistic';

import moment from 'moment';
import { GetCost } from "../../../api/usms";
import { getSthousandsFormatNum, formatBillUnit } from '../utils/common';
import { Loading } from '../components';

const CostText = "成本 = 各通道发送成功的短信提交条数*通道单价";
const ProductRevenueText = "产品侧收入";
const CompanyRevenueText = "公司侧收入";

/* 成本/收入统计 */
function BillOverview(props) {

  const { dateRange } = props;

  const [dateStatistics, setDateStatistics] = useState({});
  const [dateLoading, setDateLoading] = useState(false);
  const [beforeStatistics, setBeforeStatistics] = useState({}); // 上一周期的数据，用于对比数据
  const [beforeLoading, setBeforeLoading] = useState(false);

  useEffect(() => {
    changeDateRange(dateRange);
    // eslint-disable-next-line
  }, [dateRange])

  const getCostStatistics = (dates) => {
    setDateLoading(true);
    const data = {
      StartTime: moment(dates[0]).unix(),
      EndTime: moment(dates[1]).unix(),
    }
    GetCost(data).then(res => {
      const data = getStatisticsData(res || {});
      setDateStatistics(data);
      setDateLoading(false);
    }).catch(e => {
      Toast.fail(e.message || "获取数据失败");
      setDateLoading(false);
    });
  }

  // 获取上一周期的数据
  const getBeforeCostStatistics = (dates) => {
    setBeforeLoading(true);
    const difference = dates[1].unix() - dates[0].unix(); //时间差
    const data = {
      StartTime: moment(dates[0]).unix() - difference - 1,
      EndTime: moment(dates[1]).unix() - difference - 1,
    }
    GetCost(data).then(res => {
      const data = getStatisticsData(res || {});
      setBeforeStatistics(data);
      setBeforeLoading(false);
    }).catch(e => {
      Toast.fail(e.message || "获取数据失败");
      setBeforeLoading(false);
    });
  }

  const getStatisticsData = (data) => {
    const statistics = {
      ProductRevenue: data.ProductRevenue ? data.ProductRevenue.Total : 0,
      // ProductDomesticRevenue: data.ProductRevenue ? data.ProductRevenue.Domestic : 0,
      ProductForeignRevenue: data.ProductRevenue ? data.ProductRevenue.Foreign : 0,
      CompanyRevenue: data.CompanyRevenue ? data.CompanyRevenue.Total : 0,
      // CompanyDomesticRevenue: data.CompanyRevenue ? data.CompanyRevenue.Domestic : 0,
      CompanyForeignRevenue: data.CompanyRevenue ? data.CompanyRevenue.Foreign : 0,
      Cost: data.Cost ? data.Cost.Total : 0,
      // DomesticCost: data.Cost ? data.Cost.Domestic : 0,
      ForeignCost: data.Cost ? data.Cost.Foreign : 0,
    }
    return statistics
  }

  const getNumberFormat = (num) => {
    if (num) {
      // 美元单位为分，转化成美元，再保留两位小数
      // const yNum = num.toFixed(2);
      // 格式为千分位
      const formatNum = getSthousandsFormatNum(num);
      return formatNum
    }
    return '0.00'
  }

  const changeDateRange = (rangeDates) => {
    getCostStatistics(rangeDates);
    getBeforeCostStatistics(rangeDates);
  }

  return <Loading loading={dateLoading || beforeLoading}>
    <Card size="small" >
      <Card.Header title="整体概览" />
      <Card.Body>
        <Statistic
          style={{ marginBottom: '10px' }}
          title="产品收入"
          description={ProductRevenueText}
          data={formatBillUnit(dateStatistics.ProductRevenue, 2)}
          unit="美元"
          renderData={getNumberFormat}
          compareData={[
            // {
            //     name: "国内",
            //     data: dateStatistics.ProductDomesticRevenue,
            //     beforeData: beforeStatistics.ProductDomesticRevenue
            // },
            {
              name: "国外",
              data: formatBillUnit(dateStatistics.ProductForeignRevenue, 2),
              beforeData: formatBillUnit(beforeStatistics.ProductForeignRevenue, 2)
            }
          ]} />
        <Statistic
          style={{ marginBottom: '10px' }}
          title="公司收入"
          description={CompanyRevenueText}
          data={formatBillUnit(dateStatistics.CompanyRevenue, 2)}
          unit="美元"
          renderData={getNumberFormat}
          compareData={[
            // {
            //     name: "国内",
            //     data: dateStatistics.CompanyDomesticRevenue,
            //     beforeData: beforeStatistics.CompanyDomesticRevenue
            // },
            {
              name: "国外",
              data: formatBillUnit(dateStatistics.CompanyForeignRevenue, 2),
              beforeData: formatBillUnit(beforeStatistics.CompanyForeignRevenue, 2)
            }
          ]} />
        <Statistic
          title="成本"
          description={CostText}
          data={formatBillUnit(dateStatistics.Cost, 2)}
          unit="美元"
          renderData={getNumberFormat}
          compareData={[
            // {
            //     name: "国内",
            //     data: dateStatistics.DomesticCost,
            //     beforeData: beforeStatistics.DomesticCost
            // },
            {
              name: "国外",
              data: formatBillUnit(dateStatistics.ForeignCost, 2),
              beforeData: formatBillUnit(beforeStatistics.ForeignCost, 2)
            }
          ]} />
      </Card.Body>
    </Card>
  </Loading>
}
export default BillOverview